var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"indeterminate":true,"height":"5","active":_vm.active}})}
var staticRenderFns = []

export { render, staticRenderFns }